import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delegate-home-page',
  templateUrl: './delegate-home-page.component.html',
  styleUrls: ['./delegate-home-page.component.scss']
})
export class DelegateHomePageComponent implements OnInit {
  sectionTitle = 'Welcome to Zenplans'
  DHPNavPlans = {
      viewSharedPlans: 'View shared plans',
      createOwnPlan: 'Create my own plan',
      firstDataInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      scdDataInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }

  constructor() { }

  ngOnInit() {
  }

}
